import classNames from 'classnames';
import {
  ContentBlock,
  FlexContainer,
  Modal,
  PartialWidthContainer,
  PropertyBlock,
  Txt,
  Icon,
} from 'components';
import { observer } from 'mobx-react-lite';
import { useCallback, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { fromSwiftDate } from 'helpers/swiftDateFormatter';
import { useTenancies } from 'state';
import { LinkToTenancy } from './components';
import styles from './TenanciesListScreen.module.scss';

/**
 * TenanciesListScreen
 *
 * @return {JSX.Element}
 */
const TenanciesListScreen = ({ className }) => {
  const [isLinkOpen, setIsLinkOpen] = useState(false);
  const navigate = useNavigate();
  const tenanciesDocsArray = useTenancies();

  const handleTenancyClick = useCallback(
    (id) => () => navigate(`view/${id}`),
    [navigate]
  );

  const handlePastTenancies = () => navigate(`past`);
  const handleShare = () => {
    const shareData = {
      title: 'Propa',
      text: 'A dedicated app for Landlords and Tenants to have a shared space to communicate, pay and be accountable for throughout tenancy process.',
      url: 'https://propa.web.app',
    };

    try {
      return navigator.share(shareData);
    } catch (e) {
      console.warn('Failed to share', e);
    }
  };

  const handleLinkClick = () => {
    console.log('link click');
    setIsLinkOpen(true);
  };

  const handleLinkClose = () => {
    setIsLinkOpen(false);
  };

  const { activeTenancies, pastTenancies } = tenanciesDocsArray;

  // console.log(futureTenancy);

  return (
    <PartialWidthContainer
      className={classNames(
        styles.TenanciesListScreen,
        className,
        `${TenanciesListScreen.displayName}`
      )}
      column
      gap
      flex
      small
    >
      <Helmet title="Tenancies" />
      <Txt xxx>Your tenancies</Txt>
      {activeTenancies?.length ? (
        activeTenancies.map((tenancyState) => {
          const tenancyData = tenancyState.data;
          const propertyData = tenancyState.property?.data;

          console.log(tenancyData, propertyData);

          return (
            <PropertyBlock
              onClick={handleTenancyClick(tenancyState.id)}
              key={tenancyState.id}
              imageUrls={propertyData.imageUrls}
              tenants={tenancyData.tenantCount}
              bathroomCount={propertyData.bathroomCount}
              bedroomCount={propertyData.bedroomCount}
              deposit={tenancyData.payments.rentAmount}
              postcode={propertyData.address.name}
              startDate={fromSwiftDate(tenancyData.dates.startDate)}
              endDate={fromSwiftDate(tenancyData.dates.endDate)}
            />
          );
        })
      ) : (
        <>
          <ContentBlock gap column>
            <Txt xx>No upcoming tenancies</Txt>
            <Txt>You currently don’t have any future tenancies setup.</Txt>
            <Txt>
              To link to your tenancy tap the button in the email we sent. Then
              you’ll have access to all your important tenancy information.
            </Txt>
          </ContentBlock>
        </>
      )}
      <ContentBlock
        black
        gap
        spaceBetween
        alignCenter
        onClick={handleLinkClick}
      >
        <FlexContainer column gapHalf>
          <Txt caption>LINKING</Txt>
          <Txt bold xxx>
            Tap here to link
          </Txt>
        </FlexContainer>
        <Icon name="link" x />
      </ContentBlock>
      {!!navigator.share ? (
        <ContentBlock blue row gap alignCenter onClick={handleShare}>
          <FlexContainer flex column gapHalf>
            <Txt xx>Send to your landlord or manager</Txt>
            <Txt>
              Want to save money and have a clearer picture of your tenancy and
              all the information that surrounds it? Send an app invite to your
              landlord or manager by tapping here.
            </Txt>
          </FlexContainer>
          <Icon name="share2" x />
        </ContentBlock>
      ) : null}
      {pastTenancies?.length ? (
        <ContentBlock row gap black alignCenter onClick={handlePastTenancies}>
          <FlexContainer flex>
            <Txt>Past tenancies</Txt>
          </FlexContainer>
          <Icon name="goto" />
        </ContentBlock>
      ) : null}
      {isLinkOpen ? (
        <Modal
          onClose={handleLinkClose}
          title="Link to a Tenancy"
          showCloseButton
        >
          <LinkToTenancy onSuccess={handleLinkClose} />
        </Modal>
      ) : null}
    </PartialWidthContainer>
  );
};

TenanciesListScreen.displayName = 'TenanciesListScreen';

export default observer(TenanciesListScreen);
